/**
 * Resolves the post-login redirect target to a safe internal path only.
 *
 * The `redirect` value comes from the URL query string (e.g. written by
 * ProtectedRoute when bouncing an unauthenticated visitor to /login). Never
 * trust it blindly: external URLs, protocol-relative URLs, scheme-prefixed
 * values and parent-directory traversal are rejected and the fallback is
 * returned instead.
 */
export function getSafeRedirectPath(raw: string | null, fallback: string): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/')) return fallback;
  if (raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return fallback;
  if (raw.split('/').includes('..')) return fallback;
  return raw;
}
